const AssetName = ({ assetName, assetId }) => {
    return (
        <div>
            <h1>{assetName + " (" + assetId + ")"}</h1>
        </div>
    );
};

export default AssetName;
